import { CommonEntrypoint } from "entrypoint/CommonEntrypoint"; 
import 'presentation/style/index.scss'; 
import StaffAndVesselCodeMaintenanceCont from "presentation/view/container/StaffAndVesselCode/StaffAndVesselCodeContMain"; 
CommonEntrypoint(<StaffAndVesselCodeMaintenanceCont/>) 
